var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:("ims-icon material-icons size-" + _vm.size + " text-" + _vm.color)},[_vm._v(" "+_vm._s(_vm.icon || _vm.name)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }